import type { Placement } from '../placements';
import Placements from '../placements';

interface LocalStorageEntry {
  [key: string]: number;
}

const placementsWithCapping: Placement[] = [
  Placements.PRESCREEN,
  Placements.SLIDE_UP,
];

const getLocalStorageKey = (placement: Placement): string => {
  return `braze.${placement}.time`;
};

const getLocalStorageEntry = (placement: Placement): LocalStorageEntry => {
  return JSON.parse(
    window.localStorage.getItem(getLocalStorageKey(placement)) || '{}'
  );
};

const setLocalStorageEntry = (
  entry: LocalStorageEntry,
  placement: Placement
): void => {
  window.localStorage.setItem(
    getLocalStorageKey(placement),
    JSON.stringify(entry)
  );
};

const getTimestampBySection = (
  section: string,
  placement: Placement
): number => {
  const entry = getLocalStorageEntry(placement);
  return entry?.[section] ?? 0;
};

const hasFrequencyCapping = (
  section: string,
  placement: Placement,
  ignoreCapping?: string
): number | boolean => {
  if (placementsWithCapping.includes(placement) && !ignoreCapping) {
    const today4am = new Date().setHours(4, 0, 0, 0);
    return getTimestampBySection(section, placement) > today4am;
  }

  return false;
};

const setFrequencyCapping = (section: string, placement: Placement): void => {
  if (placementsWithCapping.includes(placement)) {
    const entry = getLocalStorageEntry(placement);
    entry[section] = Date.now();
    setLocalStorageEntry(entry, placement);
  }
};

export { hasFrequencyCapping, setFrequencyCapping, setLocalStorageEntry };
